/* Kingpin PDP v2 — gallery, add-ons, add to cart, FAQ, sticky bar */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initBuy(root) {
    var form = root.querySelector('[data-kp-form]');
    if (!form) return;
    var base = parseInt(form.dataset.price, 10) || 0;
    var qtyEl = form.querySelector('[data-kp-qty]');
    var totEl = form.querySelector('[data-kp-total]');
    var btn = form.querySelector('[data-kp-atc]');
    var q = 1;

    function calc() {
      var t = base;
      root.querySelectorAll('[data-kp-addon].on').forEach(function (a) {
        t += parseInt(a.dataset.price, 10) || 0;
      });
      if (totEl) totEl.textContent = '· ' + money(base * q + (t - base));
      if (qtyEl) qtyEl.textContent = q;
    }

    root.querySelectorAll('[data-kp-addon]').forEach(function (a) {
      a.addEventListener('click', function () {
        a.classList.toggle('on');
        a.setAttribute('aria-pressed', a.classList.contains('on'));
        calc();
      });
    });
    root.querySelectorAll('[data-kp-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        q = Math.max(1, q + parseInt(b.dataset.kpQ, 10));
        calc();
      });
    });
    calc();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // 2026-10-02: backordered items carry a "Backorder" note (map from snippets/kp-backorder.liquid)
      function bo(item) {
        var t = window.kpBO && window.kpBO[item.id];
        if (t) item.properties = { Backorder: t };
        return item;
      }
      var items = [bo({ id: parseInt(form.dataset.variant, 10), quantity: q })];
      root.querySelectorAll('[data-kp-addon].on').forEach(function (a) {
        items.push(bo({ id: parseInt(a.dataset.variant, 10), quantity: Math.max(1, parseInt(a.dataset.qty, 10) || 1) }));
      });
      btn.disabled = true;
      fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw j;
            return j;
          });
        })
        .then(function (j) {
          btn.disabled = false;
          var ev = new CustomEvent('ajaxProduct:added', { detail: { product: j }, bubbles: true });
          document.dispatchEvent(ev);
          if (!document.querySelector('#CartDrawer, [data-cart-drawer], .drawer--right')) {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          btn.disabled = false;
          var msg = form.querySelector('[data-kp-err]');
          if (msg) {
            msg.textContent = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
            msg.hidden = false;
          }
        });
    });

    // sticky bar (phones)
    var sticky = root.querySelector('[data-kp-sticky]');
    if (sticky && btn) {
      var check = function () {
        sticky.classList.toggle('kp-up', btn.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', check, { passive: true });
      check();
      var sbtn = sticky.querySelector('button');
      if (sbtn) sbtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else btn.click();
      });
    }
  }

  function initGallery(root) {
    var main = root.querySelector('[data-kp-main]');
    root.querySelectorAll('[data-kp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var tpl = t.querySelector('template');
        if (main && tpl) main.innerHTML = tpl.innerHTML;
        root.querySelectorAll('[data-kp-thumb]').forEach(function (x) { x.classList.toggle('on', x === t); });
      });
    });
    var all = root.querySelector('[data-kp-all]');
    if (all) all.addEventListener('click', function () {
      var g = root.querySelector('.gal');
      g.classList.toggle('all-open');
      all.textContent = g.classList.contains('all-open') ? all.dataset.less : all.dataset.more;
    });
    var sw = root.querySelector('.mswipe');
    var dots = root.querySelectorAll('.dots i');
    if (sw && dots.length) sw.addEventListener('scroll', function () {
      var i = Math.round(sw.scrollLeft / sw.clientWidth);
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }, { passive: true });
  }

  function initFaq(root) {
    root.querySelectorAll('.faq button').forEach(function (b) {
      b.addEventListener('click', function () {
        b.parentElement.classList.toggle('op');
        b.setAttribute('aria-expanded', b.parentElement.classList.contains('op'));
      });
    });
  }

  function boot() {
    document.querySelectorAll('.kp-pdp').forEach(function (r) {
      if (r.dataset.kpInit) return;
      r.dataset.kpInit = 1;
      initBuy(r); initGallery(r); initFaq(r);
    });
  }
  // open an FAQ answer when a link points at it (e.g. "Which size do I need?")
  function openFaq(hash) {
    if (!hash || hash.charAt(0) !== '#') return;
    var t = document.getElementById(hash.slice(1));
    if (!t || !t.parentElement || !t.parentElement.classList.contains('faq')) return;
    t.classList.add('op');
    var b = t.querySelector('button');
    if (b) b.setAttribute('aria-expanded', 'true');
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (a) openFaq(a.getAttribute('href'));
  });
  window.addEventListener('hashchange', function () { openFaq(location.hash); });

  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  openFaq(location.hash);
  document.addEventListener('shopify:section:load', boot);
})();
